import html2canvas from 'html2canvas';

export const takeScreenshot = async () => {
    const canvas = await html2canvas(document.documentElement, {
        height: document.documentElement.scrollHeight,
        width: document.documentElement.scrollWidth,
        scale: 2,
        useCORS: true,
        logging: false,
        windowWidth: document.documentElement.scrollWidth,
    windowHeight: document.documentElement.scrollHeight,
    scrollX: 0,
    scrollY: 0,
  });

  // Convert canvas to blob
  const blob = await new Promise(resolve => {
    canvas.toBlob(resolve, 'image/png', 1.0);
  });
  return blob;
}